import { usePathname, useRouter } from 'next/navigation'
import { ReactNode, useEffect, useState } from 'react'

import { PageLoading } from '@/components'
import { useAppSelector } from '@/libs/hooks/use-app-selector'

type TAccountDeletionCheckpointProps = {
  children: ReactNode
}

export default function AccountDeletionCheckpoint({
  children,
}: Readonly<TAccountDeletionCheckpointProps>) {
  const router = useRouter()
  const pathname = usePathname()
  const { accountDeletion } = useAppSelector((state) => state.ui)
  const [isLoading, setIsLoading] = useState(false)

  const accountDeletionPathname = '/account-deletion'
  const whitelistedPaths = [accountDeletionPathname, '/articles']

  useEffect(() => {
    const isWhitelistedPath = whitelistedPaths.some(
      (path) => pathname === path || pathname.startsWith(path),
    )

    if (accountDeletion && !isWhitelistedPath) {
      setIsLoading(true)
      router.push(accountDeletionPathname)
    } else {
      setIsLoading(false)
    }
  }, [accountDeletion, pathname, router])

  if (isLoading) {
    return <PageLoading show />
  }

  return <>{children}</>
}
